module.exports = __webpack_public_path__ + "static/media/big-lucky-icon-green-bg-gold-1024x1024-1024x1024.2219e92e.png";